import {
	HemisphereLight,
	DirectionalLight,
	PointLight,
	PointLightHelper,
} from 'three';
import { ProjectRenderer } from '../ProjectRenderer';

export class LightController {
	private frontLight = new PointLight(0xffffff, 1);
	private hemiLight = new HemisphereLight(0xffffff, 0x444444, 1.2);
	private keyLight = new DirectionalLight(0xffffff, 1.5);
	private rimLight = new DirectionalLight(0xffffff, 0.9);
	private fillLight = new DirectionalLight(0xffffff, 0.7);

	constructor(private renderer: ProjectRenderer) {
		this.renderer = renderer;
		this.init();
	}

	private init() {
		this.frontLight.position.set(0, 0, 1);

		this.keyLight.position.set(3, 5, 5);
		this.rimLight.position.set(-3, 3, -4);
		this.fillLight.position.set(0, 2, -2);

		if (this.renderer.isTouchDevice) {
			this.renderer.scene.add(this.hemiLight);
			this.renderer.scene.add(this.keyLight);
			this.renderer.scene.add(this.rimLight);
			this.renderer.scene.add(this.fillLight);
		}

		this.renderer.scene.add(this.frontLight);

		if (this.renderer.isDev) {
			this.renderer.scene.add(
				new PointLightHelper(this.frontLight, 0.5, 0xff0000)
			);
		}
	}
}
